import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'containsPipe', standalone: true })
export class ContainsPipe implements PipeTransform {
  transform(items: unknown[], searchTerm: string): boolean {
    if (!items || !searchTerm) {
      return false;
    }

    return items.some(item => item === searchTerm);
  }
}
